import { render } from "./NoticeStat.vue?vue&type=template&id=230bd73a&scoped=true"
import script from "./NoticeStat.vue?vue&type=script&lang=js"
export * from "./NoticeStat.vue?vue&type=script&lang=js"

import "./NoticeStat.vue?vue&type=style&index=0&id=230bd73a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230bd73a"]])

export default __exports__